
import { mapState } from 'vuex'

export default {
  props: ['owner', 'ignoreDepartment'],
  computed: {
    ...mapState(['env']),
    label () {
      let label = this.owner.name
      if (this.owner.department && !this.ignoreDepartment) label += ' - ' + (this.owner.departmentName || this.owner.department)
      if (this.owner.role) label += ` (${this.owner.role})`
      return label
    }
  }
}
